import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModelsModule } from '@nibtravel/shared/util/models';

import { CreditCardService } from './creditCard/credit-card.service';
import { PolicyHolderService } from './policyHolder/policy-holder.service';
import { Store } from '@ngxs/store';

@NgModule({
  imports: [CommonModule, ModelsModule],
  providers: [CreditCardService, PolicyHolderService, Store],
})
export class ServiceModule {}
